import { Grid, TableCell, TableRow } from '@mui/material';
import React from 'react';
import { getFileUrl } from '../../../archivos/ArchivosAction';

const ExpandedEntidadesComponent = ({ data, rowData }) => {
  return (
    <TableRow>
      <TableCell colSpan={rowData.length} sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={12} md={3} align="center">
            <strong>Logo:</strong>
            <br />
            <img
              src={getFileUrl(data.imgLogo)}
              width={100}
              alt={`imgLogo${data.id}`}
            />
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Fondo:</strong>
            <br />
            <img
              src={getFileUrl(data.imgFondo)}
              width={100}
              alt={`imgFondo${data.id}`}
            />
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>País:</strong>
            <br />
            {data.direccion.ciudad.estado.pais.pais || 'Sin descripción'}
            <br />
            <strong>Estado:</strong>
            <br />
            {data.direccion.ciudad.estado.estado}
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Ciudad:</strong>
            <br />
            {data.direccion.ciudad.ciudad}
            <br />
            <strong>Dirección:</strong>
            <br />
            {data.direccion.direccion || 'Sin descripción'}
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Latitud:</strong>
            <br />
            {data.direccion.latitud || '0.0'}
            <br />
            <strong>Longitud:</strong>
            <br />
            {data.direccion.longitud || '0.0'}
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Fecha de creación:</strong>
            <br />
            {data.createdAt}
            <br />
            <strong>Fecha de edición:</strong>
            <br />
            {data.updatedAt}
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default ExpandedEntidadesComponent;
